import { render } from "./Subs.vue?vue&type=template&id=4032e62c&scoped=true"
import script from "./Subs.vue?vue&type=script&lang=js"
export * from "./Subs.vue?vue&type=script&lang=js"

import "./Subs.vue?vue&type=style&index=0&id=4032e62c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4032e62c"]])

export default __exports__